export default __webpack_public_path__ + "mobile_bottom2.f6885b.png";